import * as React from 'react';

import { Pagination } from 'antd';

import { useProductChangeHistory } from 'v2/hooks/useProductChangeHistory';
import type { ChangeHistoryContentItem } from 'v2/interfaces/productChangeHistory';

import ChangeHistoryDetails from './ChangeHistoryDetails';
import { ChangeHistoryItem } from '../ChangeHistoryItem';
import { initialPagination } from '../constants';
import type { ChangeHistoryFilterFormValues, ProductData } from '../constants';

type ChangeHistoryContentProps = {
  productData: ProductData;
  filtersForm: ChangeHistoryFilterFormValues;
};

export const ChangeHistoryContent = ({ productData, filtersForm }: ChangeHistoryContentProps) => {
  const [pagination, setPagination] = React.useState(initialPagination);
  const [selectedItem, setSelectedItem] = React.useState(null);
  const [openDetails, setOpenDetails] = React.useState(false);
  const [editedAtDate, editedAtFinalDate] = filtersForm.dates;

  const changeHistoryQuery = useProductChangeHistory({
    productId: productData.id,
    filter: {
      page: pagination.page + 1,
      per_page: pagination.perPage,
      edited_at: editedAtDate,
      edited_at_final: editedAtFinalDate,
      user_id: filtersForm.user_modifier
    }
  });

  const data = changeHistoryQuery.data?.data;
  const queryPagination = changeHistoryQuery.data?.pagination;

  const handlePageChange = (page: number, pageSize: number) => {
    setPagination(filter => ({
      ...filter,
      page: page - 1,
      perPage: pageSize
    }));
  };

  const handleOpenDetailsModal = (data: ChangeHistoryContentItem) => {
    setSelectedItem({
      productId: productData.id,
      ...data
    });
    setOpenDetails(true);
  };

  const handleCloseDetailsModal = () => {
    setSelectedItem(null);
    setOpenDetails(false);
  };

  if (changeHistoryQuery.isLoading) return <div>Carregando...</div>;
  if (changeHistoryQuery.isError) return <div>Carregamento falhou, tente novamente mais tarde.</div>;
  if (data.length === 0) return <div>Não há itens para exibir.</div>;

  return (
    <>
      <div className='max-h-[calc(100vh-320px)] overflow-auto'>
        {data.map(item => (
          <ChangeHistoryItem key={item.historyCreatedAt} content={item} onOpenDetails={handleOpenDetailsModal} />
        ))}
      </div>

      <div className='mt-4 flex justify-end'>
        <Pagination
          total={queryPagination.total_items}
          current={pagination.page + 1}
          pageSize={pagination.perPage}
          onChange={handlePageChange}
          showSizeChanger
          pageSizeOptions={[10, 20, 30, 40]}
        />
      </div>

      {!!openDetails && (
        <ChangeHistoryDetails isOpen={openDetails} onClose={handleCloseDetailsModal} data={selectedItem} />
      )}
    </>
  );
};
